<template>
  <div class="px-4 sm:px-6 lg:px-8">
    <div class="w-full flex justify-between items-center bg-blue-200 text-sm px-4 py-2 mb-4">
      提示：当脚本使用“打开浏览器”组件且操作浏览器类型为“指纹浏览器”，发布应用时需要填写指纹组件Token授权。
    </div>
    <div class="sm:flex sm:justify-between sm:items-center">
      <nav class="space-x-4 hidden sm:block pb-4 mt-3" aria-label="Tabs">
        应用Token已使用指纹环境数量({{user.fb_app_use_limit}})
      </nav>
      <a @click="batchAdd" type="button" class="inline-flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-1 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto cursor-pointer">创建Token</a>
    </div>
    <div class="mt-4 flex flex-col">
      <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
          <div class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
            <table class="min-w-full divide-y divide-gray-300">
              <thead class="bg-gray-50">
                <tr>
                  <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">Token</th>
                  <th scope="col" class="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">分身数</th>
                  <th scope="col" class="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">应用名称</th>
                  <th scope="col" class="py-3.5 px-3 pr-3 text-left text-sm font-semibold text-gray-900">备注</th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">创建时间</th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">状态</th>
                  <th scope="col" class="relative py-3.5 pl-3 pr-4 sm:pr-6">
                    <span class="sr-only">操作</span>
                  </th>
                </tr>
              </thead>
              <tbody class="divide-y divide-gray-200 bg-white">
                <tr v-for="item in tableData" :key="item.id">
                  <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">{{item.Token}}</td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                    <template v-if="item.RealValue == item.Value || item.RealValue == 0">{{item.Value}}</template>
                    <template v-else>{{item.RealValue}}/{{item.Value}}</template>
                  </td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{item.AppName || '--'}}</td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{item.Remark}}</td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{item.CreateTime}}</td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                    <span v-if="item.Status == 1" class="text-[#f00]">已使用</span>
                    <span v-else-if="item.Status == 0" class="text-green-600">待使用</span>
                    <span class="text-red" v-else>--</span>
                  </td>
                  <td class="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                    <a href="javascript:;" class="text-gray-500 hover:text-gray-900 inline-block mr-1" @click="copy(item.Token)" title="点击复制Token">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-4 w-4 text-gray-500">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M11.35 3.836c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m8.9-4.414c.376.023.75.05 1.124.08 1.131.094 1.976 1.057 1.976 2.192V16.5A2.25 2.25 0 0118 18.75h-2.25m-7.5-10.5H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V18.75m-7.5-10.5h6.375c.621 0 1.125.504 1.125 1.125v9.375m-8.25-3l1.5 1.5 3-3.75" />
                      </svg>
                    </a>
                    <a href="javascript:;" class="text-gray-500 hover:text-gray-900 inline-block mr-1" @click="reset(item.Token)" title="点击重置应用Token" v-if="item.RealValue">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-4 w-4 text-gray-500">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
                      </svg>
                    </a>
                    <a href="javascript:;" class="text-gray-500 hover:text-gray-900 inline-block mr-1" title="删除" @click="deleteItem(item)">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                      </svg>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <Pagination :size="query.PageSize" :page="query.PageIndex" :total="total" @change="changePage" />
    <Alert :visible.sync="alertShow" :msg="alterMsg" ref="alert" />
    <Notify ref="notify" />
    <Modal :visible.sync="addDialog" title="创建Token" @submit="batchCode()" submitText="添加" width="max-w-xl">
      <div class="space-y-6 sm:space-y-0 sm:py-0 my-4" v-if="addDialog">
        <div class="space-y-1 px-4 sm:grid sm:grid-cols-4 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-2">
          <div>
            <label for="project-description" class="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2">Token数量</label>
          </div>
          <div class="sm:col-span-3">
            <input v-model="addForm.value" type="number" autocomplete="off" name="project-name" class="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
            <div class="inline-block ml-1">剩余可用{{user.total_fb_limit}}</div>
          </div>
        </div>
        <div class="space-y-1 px-4 sm:grid sm:grid-cols-4 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-2">
          <div>
            <label for="project-description" class="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2">备注</label>
          </div>
          <div class="sm:col-span-3">
            <textarea v-model="addForm.remark" name="" id="" cols="30" rows="5" class="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"></textarea>
          </div>
        </div>
      </div>
    </Modal>
    <Modal :visible.sync="detailDialog" title="激活码详情" :ActionBtnShow="false" width="max-w-3xl">
      <div class="space-y-6 sm:space-y-0 my-4 mx-2 px-4 py-0" v-if="Object.keys(detail)">
        <div>
          <h2 class="text-base font-extrabold text-gray-900 mt-6">{{detail.AppName}}</h2>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import Pagination from '../components/Pagination.vue'
import Alert from '../components/Alert.vue'
import Notify from '../components/Notification.vue'
import { pageList, create, remove, resetToken } from '../api/FbToken.js'
import { getCurrentUser } from '../api/App'
import { debounce } from 'lodash'
import Modal from '../components/Modal.vue'
export default {
  name: 'CommentList',
  components: { Alert, Notify, Pagination, Modal },
  data () {
    return {
      alertShow: false,
      alterMsg: undefined,
      modalShow: false,
      detailDialog: false,
      query: {
        PageIndex: 1,
        PageSize: 10,
        Status: -1,
        sort: '-id'
      },
      detail: {},
      tableData: [],
      total: 0,
      addDialog: false,
      addForm: {
        Count: 1,
        UserId: 0,
        CodeType: 0,
        ValidityPeriodDay: 0,
        AppKey: '',
        AppName: '',
        IsVip: false
      },
      user: null
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    getUser () {
      getCurrentUser().then(res => {
        this.user = res.data.data
      }).catch(err => { console.log(err) })
    },
    batchAdd () {
      this.addForm = {
        value: 1,
        remark: ''
      }
      this.addDialog = true
    },
    batchCode () {
      this.addForm.value = parseInt(this.addForm.value)
      if (this.addForm.value > parseInt(this.user.total_fb_limit)) {
        this.notifyShow({ title: 'Token数量非法！', type: 'warn' })
        return
      }
      create(this.addForm).then((res) => {
        if (res.data.state) {
          this.notifyShow({ title: 'Token添加成功！' })
          this.addDialog = false
          this.getList()
        } else {
          this.notifyShow({ title: res.data.message, type: 'warn' })
        }
        this.getUser()
      }).catch((err) => { this.notifyShow({ title: err, type: 'warn' }) })
    },
    copy (text) {
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            this.notifyShow({ title: '已复制到剪切板' })
          })
          .catch((err) => {
            console.error('无法复制此文本：', err)
            this.notifyShow({ title: '无法复制此文本：', type: 'error' })
          })
      } else {
        // 创建text area
        const textArea = document.createElement('textarea')
        textArea.value = text
        document.body.appendChild(textArea)
        textArea.style.position = 'absolute'
        textArea.style.opacity = 0
        textArea.style.left = '-999999px'
        textArea.style.top = '-999999px'
        textArea.focus()
        textArea.select()
        return new Promise((resolve, reject) => {
          // 执行复制命令并移除文本框
          document.execCommand('copy') ? resolve() : reject(new Error('出错了'))
          textArea.remove()
        }).then(
          () => {
            this.notifyShow({ title: '已复制到剪切板' })
          },
          (err) => {
            console.error('无法复制此文本：', err)
            this.notifyShow({ title: '无法复制此文本', type: 'error' })
          }
        )
      }
    },
    deleteItem (item) {
      this.alertShow = true
      this.alterMsg = undefined
      new Promise((resolve, reject) => {
        const instance = this.$refs.alert
        instance.confirm = () => {
          this.alertShow = false
          resolve()
        }
        instance.cancel = () => {
          this.alertShow = false
          reject()
        }
      }).then(() => {
        remove(item.Id).then(() => {
          this.notifyShow({ title: '删除成功' })
          this.getList()
        })
      }).catch(() => { console.log('cancel') })
    },
    reset (token) {
      this.alertShow = true
      this.alterMsg = '是否确定重置当前应用Token'
      new Promise((resolve, reject) => {
        const instance = this.$refs.alert
        instance.confirm = () => {
          this.alertShow = false
          resolve()
        }
        instance.cancel = () => {
          this.alertShow = false
          reject()
        }
      }).then(() => {
        resetToken(token).then(() => {
          this.notifyShow({ title: '重置成功' })
          this.getList()
        })
      }).catch(() => { console.log('cancel') })
    },
    changePage (page) {
      this.query.PageIndex = page
    },
    notifyShow (msg = { title: '', desc: '', timeout: 3000 }) {
      this.$refs.notify.show(msg)
    },
    refreshData: debounce(
      function () {
        this.getList()
      },
      800
    ),
    getList () {
      this.getUser()
      this.loading = true
      pageList(this.queryString).then(res => {
        const data = res.data.data
        if (!data.list) data.list = []
        this.tableData = data.list
        this.query.PageIndex = data.page ? data.page : 1
        this.total = data.total ? data.total : 0
        // this.$refs.multipleTable.doLayout()
      }).catch((err) => {
        console.log(err)
      }).finally(() => {
        this.loading = false
      })
    }
  },
  watch: {
    query: {
      handler: function () {
        this.refreshData()
      },
      deep: true
    }
  },
  computed: {
    queryString: function () {
      return Object.keys(this.query).filter(key => this.query[key] !== '')
        .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(this.query[key]))
        .join('&')
    }
  }
}
</script>
